import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    event_checkin_adminAddCheckin_Api,
    event_checkin_removeCheckin_Api,
    event_checkin_userCheckin_Api
} from "../../../../apis/event";


export const useEventCheckinApi = ({
                                       notifyListeners = {
                                           onUserCheckedIn: undefined,
                                           onUserCheckedInError: undefined,
                                           onAdminAddCheckedIn: undefined,
                                           onRemovedCheckin: undefined,
                                       },
                                   }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onUserCheckedIn = NullAsDefault,
        onUserCheckedInError = NullAsDefault,
        onAdminAddCheckedIn = NullAsDefault,
        onRemovedCheckin = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onUserCheckin, ...asyncCreating} = useAsyncAction({
        onError: (e, o) => {
            onUserCheckedInError(e, o)
        },
        query: bindQueryParam({}),
        apiInfo: event_checkin_userCheckin_Api,
        onSuccess: (result, data) => {
            // successNotify(NotificationActionTypes.CREATE, t)
            onUserCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onAdminAddCheckin, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: event_checkin_adminAddCheckin_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onAdminAddCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onRemoveCheckin, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: event_checkin_removeCheckin_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRemovedCheckin(result, data)
        },
    })


    return {
        onUserCheckin,
        onAdminAddCheckin,
        onRemoveCheckin,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
    }
}



